import { coerceNumber } from './chunk-4RYIEGE7.js';

// src/evidence/tiers.ts
var ConfidenceTier = {
  /** `>= high` — deterministic / strongly corroborated; safe to act on. */
  HIGH: "high",
  /** `>= medium` — semi-deterministic / strong heuristic; surface, allow review. */
  MEDIUM: "medium",
  /** `< medium` — probabilistic; show with the rationale, never auto-act. */
  LOW: "low"
};
var DEFAULT_TIER_CUTOFFS = { high: 0.9, medium: 0.6 };
function tierFor(score, cutoffs) {
  if (typeof score !== "number" || !Number.isFinite(score)) return ConfidenceTier.LOW;
  const high = cutoffs?.high ?? DEFAULT_TIER_CUTOFFS.high;
  const medium = cutoffs?.medium ?? DEFAULT_TIER_CUTOFFS.medium;
  if (score >= high) return ConfidenceTier.HIGH;
  if (score >= medium) return ConfidenceTier.MEDIUM;
  return ConfidenceTier.LOW;
}
var CONFIDENCE_TIER_LABELS = {
  [ConfidenceTier.HIGH]: "High confidence",
  [ConfidenceTier.MEDIUM]: "Medium confidence",
  [ConfidenceTier.LOW]: "Low confidence"
};
function formatConfidence(score, fractionDigits = 0) {
  if (typeof score !== "number" || !Number.isFinite(score)) return "";
  return `${Number((clampConfidence(score) * 100).toFixed(Math.min(4, Math.max(0, fractionDigits))))}%`;
}
function clampConfidence(score) {
  return Math.max(0, Math.min(1, score));
}
function coerceConfidence(value) {
  return coerceNumber(value) ?? null;
}
function readTierCutoffs(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const scoped = raw;
  const high = coerceConfidence(scoped.high) ?? void 0;
  const medium = coerceConfidence(scoped.medium) ?? void 0;
  return high === void 0 && medium === void 0 ? null : { high, medium };
}

export { CONFIDENCE_TIER_LABELS, ConfidenceTier, DEFAULT_TIER_CUTOFFS, clampConfidence, coerceConfidence, formatConfidence, readTierCutoffs, tierFor };
//# sourceMappingURL=chunk-OP6EVGNJ.js.map
//# sourceMappingURL=chunk-OP6EVGNJ.js.map